var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.infoDialog)?_c('div',[_c(_vm.infoDialog,{tag:"component",model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }